import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { UserLoggedInComponent } from './login/user-logged-in/user-logged-in.component';
import { UserLoginComponent } from './login/user-login/user-login.component';

@NgModule({
  imports: [
    RouterModule.forChild([{
      path: 'login',
      component: UserLoginComponent,
      data: { name: 'Login' }
    }, {
      path: 'loggedIn',
      component: UserLoggedInComponent,
      data: { name: 'Login' }
    }])
  ],
  exports: [RouterModule],
  providers: [
  ]
})
export class UserRoutingModule { }
